var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-3 border text-white text-center rounded-1"},[_vm._v(" Your pool share will go from "+_vm._s(_vm._num(_vm.poolSharesPercentFrom, 'percent'))+" to "+_vm._s(_vm._num(_vm.poolSharesPercentTo, 'percent'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }